/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * MARKETview API
 * OpenAPI spec version: 0.0.1
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ClientCohortDto
} from '../schemas';

import { customAxios } from '../../orval-mutator';
import type { ErrorType } from '../../orval-mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Authorities: **Any authenticated role**
 */
export const getClientCohorts = (
    userId: string,
    clientId: number,
 options?: SecondParameter<typeof customAxios>,signal?: AbortSignal
) => {


      return customAxios<ClientCohortDto[]>(
      {url: `/api/${userId}/clients/${clientId}/cohorts`, method: 'GET', signal
    },
      options);
    }




export const getGetClientCohortsQueryKey = (userId: string,
    clientId: number,) => {
    return [
    `/api/${userId}/clients/${clientId}/cohorts`
    ] as const;
    }


export const getGetClientCohortsQueryOptions = <TData = Awaited<ReturnType<typeof getClientCohorts>>, TError = ErrorType<unknown>>(userId: string,
    clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetClientCohortsQueryKey(userId,clientId);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getClientCohorts>>> = ({ signal }) => getClientCohorts(userId,clientId, requestOptions, signal);





   return  { queryKey, queryFn, enabled: !!(userId && clientId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetClientCohortsQueryResult = NonNullable<Awaited<ReturnType<typeof getClientCohorts>>>
export type GetClientCohortsQueryError = ErrorType<unknown>


export function useGetClientCohorts<TData = Awaited<ReturnType<typeof getClientCohorts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCohorts>>,
          TError,
          Awaited<ReturnType<typeof getClientCohorts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientCohorts<TData = Awaited<ReturnType<typeof getClientCohorts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getClientCohorts>>,
          TError,
          Awaited<ReturnType<typeof getClientCohorts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetClientCohorts<TData = Awaited<ReturnType<typeof getClientCohorts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetClientCohorts<TData = Awaited<ReturnType<typeof getClientCohorts>>, TError = ErrorType<unknown>>(
 userId: string,
    clientId: number, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getClientCohorts>>, TError, TData>>, request?: SecondParameter<typeof customAxios>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetClientCohortsQueryOptions(userId,clientId,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}






